<template>
  <div class="bar__container">
    <div class="bar__title" :class="{ 'bar__title--show': showTitle }">
      <slot />
    </div>
    <div
      class="bar"
      :style="{
        height: `${height}px`,
        width: max ? `${(itemMax / max) * 100}%` : '100%',
      }"
    >
      <div
        v-for="(item, idx) in shownItems"
        :key="item.label"
        class="bar__segment"
        :class="{ [`background-${item.color}`]: item.color }"
        :style="{
          width: `${(item.value / itemMax) * 100}%`,
        }"
      >
        <slot name="double" v-if="idx === shownItems.length - 1" />
      </div>
      <slot name="misc" />
    </div>
  </div>
</template>

<script>
import gsap from "gsap";
export default {
  props: {
    items: {
      type: Array,
      default: () => [],
    },
    max: {
      type: Number,
      default: null,
    },
    customItemMax: {
      type: Number,
      required: false,
    },
    width: {
      type: Number,
      default: 400,
    },
    height: {
      type: Number,
      default: 48,
    },
  },
  data() {
    return {
      shownItems: [],
      showTitle: false,
    };
  },
  computed: {
    itemMax() {
      return this.customItemMax
        ? this.customItemMax
        : this.items.reduce((total, item) => total + item.value, 0);
    },
  },
  methods: {
    animateItems() {
      this.shownItems = this.items.map((item) => ({ ...item, value: 0 }));
      this.shownItems.forEach((item, i) => {
        const final = this.items[i];
        gsap.to(item, {
          value: final.value,
          duration: 0.25,
          delay: i * 0.25,
          onComplete: i === 0 ? () => (this.showTitle = true) : null,
        });
      });
    },
  },
  mounted() {
    // Animate the items
    this.animateItems();
  },
  watch: {
    items: {
      handler: "animateItems",
      deep: true,
    },
  },
};
</script>

<style scoped>
.bar__container {
  width: 100%;
  margin-bottom: 5px;
}
.bar {
  position: relative;
  display: flex;
  align-items: flex-start;
  width: 100%;
}
.bar__segment {
  content: " ";
  height: 100%;
  border-right: 1px solid white;
  transition: all 0.3s ease;
}
.bar__title {
  opacity: 0;
  transition: all 0.3s ease;
}
.bar__title--show {
  opacity: 1;
}
@media screen and (max-width: 729px) {
  .bar__title {
    position: absolute;
    height: 14px;
    z-index: 2;
    margin-left: 4px;
  }
}
</style>
